import PropTypes from 'prop-types';
import React from 'react';
import { ProjectCostOverridesEditable } from './components';
import {
  useCostOverrideTableDimensions,
  useProjectCostOverridesData,
  useProjectCostOverridesViewSummary
} from './hooks';

export const ProjectCostOverrides = ({
  editable = false,
  projectSlug,
  projectCurrency
}) => {
  const {
    viewSummary,
    onViewSummaryClick
  } = useProjectCostOverridesViewSummary();

  const {
    loading: ratesLoading,
    projectRates,
    projectRateCount,
    loadingMore
  } = useProjectCostOverridesData();
  const {
    loading: dimensionsLoading,
    projectDimensions
  } = useCostOverrideTableDimensions();

  if (ratesLoading || dimensionsLoading) {
    return null;
  }

  const sharedProps = {
    projectSlug,
    projectCurrency,
    projectRates,
    projectRateCount,
    projectDimensions,
    loadingMore
  };

  return (
    <>
      <ProjectCostOverridesEditable
        {...sharedProps}
        editable={editable}
        onViewSummaryClick={onViewSummaryClick}
      />
      {viewSummary && (
        <ProjectCostOverridesEditable
          {...sharedProps}
          editable={false}
          edit={viewSummary}
          viewSummary={viewSummary}
          onCancelCallback={onViewSummaryClick}
        />
      )}
    </>
  );
};

ProjectCostOverrides.propTypes = {
  editable: PropTypes.bool,
  projectSlug: PropTypes.string,
  projectCurrency: PropTypes.object
};

export default ProjectCostOverrides;
